import { useMemo } from 'react';

import useAnalytics from 'api/useAnalytics';
import {
  DATE_DAY_MONTH_FORMAT,
  TIME_HOUR_MINUTE_FORMAT
} from 'constants/constants';

import { isDateStringHourly } from '../utils';

export const useXAxisDateFormat = (analytics: ReturnType<typeof useAnalytics>) => {
  return useMemo(() => {
    const firstTrend = analytics.getTrends?.data?.[0].values?.[0];
    if (!firstTrend?.date) {
      return DATE_DAY_MONTH_FORMAT;
    }

    if (isDateStringHourly(firstTrend.date)) {
      return TIME_HOUR_MINUTE_FORMAT;
    }

    return DATE_DAY_MONTH_FORMAT;
  }, [analytics.getTrends.data]);
}; 